import React, { useEffect, useState } from "react";
import TableHeader from "../common/MagicPageHeader";
import Header from "../common/MagicTableHeader";
import ImageComponent from "../mui/Image";
import DownloadToXlsxFile from "../../helper/DownloadToXlsxFile";
import GridTable, { Column } from "../common/GridTable";
import { useFetchTargetVsAchievementReportsQuery } from "../../store/apis/reportsApis";

interface TargetVsAchievementProps {
  selectedTab: any;
  magicPageHeaderBtn: any[];
  magicTableHeaderBtn: any[];
  params:any;
  isInvalidSearch: boolean;
  onPaginationChange: (pageNo: number) => void;
  onSearch: (searchTerm: string) => void;
}

const columns: Column[] = [
  { field: "parameter", headerText: "" , align: "center" },
  { field: "centre", headerText: "" , align: "center" },
  { field: "q1Target", headerText: " Target", align: "center" },
  { field: "q1Achieved", headerText: " Achieved", align: "center" },
  { field: "q2Target", headerText: "Target", align: "center" },
  { field: "q2Achieved", headerText: "Achieved", align: "center" },
  { field: "q3Target", headerText: "Target", align: "center" },
  { field: "q3Achieved", headerText: "Achieved", align: "center" },
  { field: "q4Target", headerText: "Target", align: "center" },
  { field: "q4Achieved", headerText: "Achieved", align: "center" },
];

const headers = [
  {
    id: "parameter",
    colSpan: 1,
    label: "Parameter",
    align: "center" as const,
    rowSpan: 2,
  },
  {
    id: "centre",
    colSpan: 1,
    label: "Centre",
    align: "center" as const,
    rowSpan: 2,
  },
  {
    id: "q1",
    colSpan: 2,
    label: "Quarter 1",
    align: "center" as const,
  },
  {
    id: "q2",
    colSpan: 2,
    label: "Quarter 2",
    align: "center" as const,
  },
  {
    id: "q3",
    colSpan: 2,
    label: "Quarter 3",
    align: "center" as const,
  },
  {
    id: "q4",
    colSpan: 2,
    label: "Quarter 4",
    align: "center" as const,
  },
];

const TargetVsAchievementTable: React.FC<TargetVsAchievementProps> = ({
  selectedTab,
  magicTableHeaderBtn,
  params,
  isInvalidSearch,
  onPaginationChange,
  onSearch,
}) => {
  const [downloadParams, setDownloadParams] = useState<any>(null);
  const [downloadTrigger, setDownloadTrigger] = useState(false);
  const filteredParams = { ...params };
  delete filteredParams.quarterMasterId;
  const {
      data: fetchedReports,isLoading
    } = useFetchTargetVsAchievementReportsQuery(filteredParams);
    const { data: downloadData ,isLoading: downloadLoading} = useFetchTargetVsAchievementReportsQuery(downloadParams, {
      skip: !downloadParams,
    });
const handleDownload = async () => {
  try {
    const downloadPayload = {
      ...filteredParams,
      pageNo: "1",
      pageSize: fetchedReports?.totalReports || "10",
    };
    setDownloadParams(downloadPayload);
    setDownloadTrigger(true); 
  } catch (error) {
    console.error("Error during download:", error);
  }
};

useEffect(()=>{
  if (downloadData && downloadTrigger) {
    const sheetData = [
      [
        "Parameter",
        "Center",
        "Q1 Target",
        "Q1 Achieved",
        "Q2 Target",
        "Q2 Achieved",
        "Q3 Target",
        "Q3 Achieved",
        "Q4 Target",
        "Q4 Achieved",
      ],
      ...(downloadData?.reports?.map((row: any) => [
        row.parameter || "-",
        row.centre || "-",
        row.q1Target || "-",
        row.q1Achieved || "-",
        row.q2Target || "-",
        row.q2Achieved || "-",
        row.q3Target || "-",
        row.q3Achieved || "-",
        row.q4Target || "-",
        row.q4Achieved || "-",
      ]) || []),
    ];

    DownloadToXlsxFile({
      fileNamePrifix: "target-vs-achievement-report",
      sheetData,
    });
    setDownloadTrigger(false);  
  }
  }, [downloadData, downloadTrigger]); 

const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "outlined",
      startIcon: (
        <ImageComponent src="/assets/images/login/exportIcon.svg" alt="ExportIcon" />
      ),
      onClick: handleDownload,
      loading: downloadLoading,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];
  const totalPages = Math.max(1, Math.ceil((fetchedReports?.totalReports || 0) / 10));
  return (
    <>
      <TableHeader
        title={`${selectedTab?.name || "Target VS Achievement"} Report`}
        subTitle="Here you can view the report with all the details."
        buttons={magicPageHeaderBtn}
        chipLabel={`${fetchedReports?.totalReports} entries`}
      />
      <Header
        buttons={magicTableHeaderBtn}
        onSearchfieldChange={(value) => onSearch(String(value))}
        isInvalidSearch={isInvalidSearch}
      />
      <GridTable
        columns={columns}
        rows={fetchedReports?.reports || []}
        headers={headers}
        loading={isLoading}
        handlePageChange={(event, pageNo) => onPaginationChange(pageNo)}
        count={totalPages}
        currentPage={parseInt(params?.pageNo) || 1}
        rowsPerPageOptions={[10, 25]}
        initialRowsPerPage={10}
        tableHeight={500}
      />
    </>
  );
};

export default TargetVsAchievementTable;
